export default __webpack_public_path__ + "static/international-metric-mobile-d328119c21a371aa0c48675d68e9f9ad.svg";